module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.26349",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6709",
      "conversations-error-reporting": "static-1.7981",
      "conversations-internal-pub-sub": "static-1.15065",
      "conversations-internal-schema": "static-1.11692",
      "conversations-message-history": "static-1.10178",
      "conversations-test-sdk": "static-1.9523",
      "conversations-visitor-experience-components": "static-1.19712",
      "head-dlb": "static-1.4210",
      "hs-promise-utils": "static-1.4589",
      "hs-test-utils": "static-1.7058",
      "hubspot-dlb": "static-2.1406",
      "HubStyleTokens": "static-2.10580",
      "I18n": "static-7.1405",
      "jasmine-immutable": "static-1.2025",
      "jasmine-runner": "static-1.5483",
      "quartz": "static-1.5821",
      "react-aria": "static-1.41",
      "react-dlb": "static-1.55",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.3603",
      "viral-links-lib": "static-1.5937",
      "visitor-ui-component-library": "static-1.5251",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3631",
      "atom": "static-1.4212",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.3854",
      "conversations-infrastructure": "static-1.8000",
      "conversations-prop-types": "static-1.6513",
      "conversations-visibility-tools": "static-1.4837",
      "conversations-visitor-message-history": "static-1.18449",
      "cssUtils": "static-1.540",
      "enviro": "static-4.313",
      "flux-actions": "static-1.280",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3063",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.8459",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.291",
      "raven": "static-3.5037",
      "react": "static-7.151",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15625",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4527",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3440",
      "sanitize-text": "static-1.7212",
      "signup-constants": "static-1.16878",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.468",
      "usage-tracker": "static-1.6525",
      "usage-tracker-core": "static-1.6375",
      "usage-tracker-multi": "static-1.4939",
      "usage-tracker-public": "static-1.6336",
      "visitor-ui-component-library-icons": "static-1.5062",
      "hs-promise-rejection-tracking": "static-1.4568",
      "raven-hubspot": "static-1.5344",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2665",
      "moment": "static-3.26",
      "quartz-core": "static-1.5040",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.3963",
      "foundations-components": "static-1.6409",
      "foundations-theming": "static-1.3368",
      "UIComponents": "static-3.7527",
      "cv-backend-services": "static-1.1250",
      "immutable-less": "static-1.3620",
      "conversations-skeleton-state": "static-1.6427",
      "icons": "static-2.592",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.3798",
      "ui-images": "static-2.901",
      "permission-components": "static-1.4439",
      "react-virtualized": "static-2.76",
      "HeadJS": "static-2.587",
      "framer-motion": "static-1.43",
      "hs-test-utils-bend-plugin": "static-1.2169",
      "msw": "static-1.39",
      "testing-library": "static-1.125",
      "i18n-data": "static-1.200",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3410",
      "quartz-core-utils": "static-1.2688",
      "signup-ui-url-generator": "static-2.7119",
      "HubStyle": "static-2.10888",
      "sassPrefix": "static-1.134",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.4942",
      "copilot-toolkit": "static-1.7761",
      "dispatcher": "static-1.115",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.660",
      "hub-http-shared-msw-handlers": "static-1.7423",
      "hubspotter-http": "static-1.3790",
      "hubspotter-http-shared-msw-handlers": "static-1.7421",
      "mobile-manifest-mixins": "static-1.358",
      "platform-navigation-bootstrap": "static-1.11484",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.332",
      "hs-story-utils": "static-1.8426",
      "bend-plugin-foundations-components": "static-1.2678",
      "floating-ui": "static-1.31",
      "foundations-theming-specialty": "static-1.1085",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.1851",
      "foundations-theming-base": "static-1.2353",
      "ts-schema": "static-1.3316",
      "chatspot-client-types": "static-1.9134",
      "chatspot-core": "static-1.17163",
      "platform-infra-nav-components": "static-1.6902"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.26349",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6709",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.7981",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.15065",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11692",
      "conversations-message-history": "/conversations-message-history/static-1.10178",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9523",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.19712",
      "head-dlb": "/head-dlb/static-1.4210",
      "hs-promise-utils": "/hs-promise-utils/static-1.4589",
      "hs-test-utils": "/hs-test-utils/static-1.7058",
      "hubspot-dlb": "/hubspot-dlb/static-2.1406",
      "HubStyleTokens": "/HubStyleTokens/static-2.10580",
      "I18n": "/I18n/static-7.1405",
      "jasmine-immutable": "/jasmine-immutable/static-1.2025",
      "jasmine-runner": "/jasmine-runner/static-1.5483",
      "quartz": "/quartz/static-1.5821",
      "react-aria": "/react-aria/static-1.41",
      "react-dlb": "/react-dlb/static-1.55",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.3603",
      "viral-links-lib": "/viral-links-lib/static-1.5937",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5251",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3631",
      "atom": "/atom/static-1.4212",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.3854",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.8000",
      "conversations-prop-types": "/conversations-prop-types/static-1.6513",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4837",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.18449",
      "cssUtils": "/cssUtils/static-1.540",
      "enviro": "/enviro/static-4.313",
      "flux-actions": "/flux-actions/static-1.280",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.8459",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.291",
      "raven": "/raven/static-3.5037",
      "react": "/react/static-7.151",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15625",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4527",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3440",
      "sanitize-text": "/sanitize-text/static-1.7212",
      "signup-constants": "/signup-constants/static-1.16878",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.468",
      "usage-tracker": "/usage-tracker/static-1.6525",
      "usage-tracker-core": "/usage-tracker-core/static-1.6375",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.4939",
      "usage-tracker-public": "/usage-tracker-public/static-1.6336",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5062",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4568",
      "raven-hubspot": "/raven-hubspot/static-1.5344",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2665",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.5040",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.3963",
      "foundations-components": "/foundations-components/static-1.6409",
      "foundations-theming": "/foundations-theming/static-1.3368",
      "UIComponents": "/UIComponents/static-3.7527",
      "cv-backend-services": "/cv-backend-services/static-1.1250",
      "immutable-less": "/immutable-less/static-1.3620",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6427",
      "icons": "/icons/static-2.592",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.3798",
      "ui-images": "/ui-images/static-2.901",
      "permission-components": "/permission-components/static-1.4439",
      "react-virtualized": "/react-virtualized/static-2.76",
      "HeadJS": "/HeadJS/static-2.587",
      "framer-motion": "/framer-motion/static-1.43",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2169",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.125",
      "i18n-data": "/i18n-data/static-1.200",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3410",
      "quartz-core-utils": "/quartz-core-utils/static-1.2688",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7119",
      "HubStyle": "/HubStyle/static-2.10888",
      "sassPrefix": "/sassPrefix/static-1.134",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4942",
      "copilot-toolkit": "/copilot-toolkit/static-1.7761",
      "dispatcher": "/dispatcher/static-1.115",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.660",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7423",
      "hubspotter-http": "/hubspotter-http/static-1.3790",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7421",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.358",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11484",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.332",
      "hs-story-utils": "/hs-story-utils/static-1.8426",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2678",
      "floating-ui": "/floating-ui/static-1.31",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1085",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1851",
      "foundations-theming-base": "/foundations-theming-base/static-1.2353",
      "ts-schema": "/ts-schema/static-1.3316",
      "chatspot-client-types": "/chatspot-client-types/static-1.9134",
      "chatspot-core": "/chatspot-core/static-1.17163",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6902"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};